export const login = (locale) => `/${locale}`;
export const register = (locale) => `/${locale}/register`;
export const registerSuccess = (locale) => `/${locale}/register/success`;
export const registrationOne = (locale) => `/${locale}/registrationOne`;
export const registerProfessionalDetail = (locale) =>
  `/${locale}/registerProfessionalDetail`;
export const registerContractDetail = (locale) =>
  `/${locale}/registerContractDetail`;
export const registerFinal = (locale) => `/${locale}/register-final`;
export const subscription = (locale) => `/${locale}/register-subscription`;
export const doctorDashboard = (locale) => `/${locale}/doctor-dashboard`;
export const doctorSchedule = (locale) => `/${locale}/doctor-schedule`;
export const doctorAppointments = (locale) => `/${locale}/doctor-appointment`;
export const doctorAppointmentsRequestDetails = (locale) =>
  `/${locale}/doctor-appointment-request-details`;
export const doctorAppointmentsUpcomingDetails = (locale) =>
  `/${locale}/doctor-appointment-upcoming-details`;
export const doctorAppointmentsPendingDetails = (locale) =>
  `/${locale}/doctor-appointment-pending-details`;
export const doctorPatient = (locale) => `/${locale}/doctor-patient`;
export const doctorPatientDetails = (locale) =>
  `/${locale}/doctor-patient-details`;
export const doctorProfile = (locale) => `/${locale}/doctor-profile`;
export const doctorEarning = (locale) => `/${locale}/doctor-earning`;
export const doctorSubscription = (locale) => `/${locale}/doctor-Subscription`;
export const doctorCancelWeb = (locale) => `/${locale}/doctor-cancel`;
export const doctorCancel = (locale, token) =>
  `/${locale}/doctor-cancel/${token}`;
export const doctorChangePlan = (locale, id, token) =>
  `/${locale}/doctor-change-plan/${id}/${token}`;
export const doctorPayment = (locale, value, token) =>
  `/${locale}/doctor-payment/${value}/${token}`;
export const paymentSuccess = (locale) => `/${locale}/payment-success`;
